import {
  createTableCellActionsInput,
  type SelectionUiInteraction,
  type SharedEventLoop,
} from '@databases/selections';
import { DatabaseLayoutType } from '@databases/types/database/view';

import {
  type SelectionInputFeature,
  SelectionFeatureKeys,
} from '../../features/types.ts';

/**
 * Dependencies required to wire table cell-action keyboard handling into a mode.
 */
export interface TableCellActionsKeyboardInputFeatureDeps {
  sharedLoop: SharedEventLoop;
  onSelectionUiInteraction?: (event: SelectionUiInteraction) => void;
}

/**
 * Registers the default table keyboard input for legacy focused-cell actions.
 *
 * This feature is intentionally always enabled for table layouts. It preserves
 * existing edit/clear/deselect behavior while navigation inputs can be added as
 * separate, independently-gated features.
 */
export function createTableCellActionsKeyboardInputFeature(
  deps: TableCellActionsKeyboardInputFeatureDeps,
): SelectionInputFeature {
  return {
    key: SelectionFeatureKeys.TABLE_CELL_ACTIONS_KEYBOARD_INPUT,
    type: 'input',
    isEnabled: (ctx) => ctx.layoutType === DatabaseLayoutType.TABLE,
    factory: (machine) =>
      createTableCellActionsInput(machine, deps.sharedLoop, {
        onSelectionUiInteraction: deps.onSelectionUiInteraction,
      }),
  };
}
